import React, { forwardRef } from 'react'
const MobileNavigationSearchView = forwardRef(
  (
    {
      name,
      action,
      searchText,
      onSearchChange,
      onSearchLeave,
      onKeyUpSearch,
      onClickClearSearch,
      autoCompleteData,
      autoCompleteIndex,
      onClickAutoCompItem,
    },
    ref
  ) => {
    const sanitizeInput = (input) => {
      return input.replaceAll('%22', '').replaceAll(' ', '+')
    }

    const handleSubmit = (e) => {
      e.preventDefault()
      window.location = `${action}?search=${sanitizeInput(
        encodeURIComponent(searchText)
      )}`
    }

    return (
      <div
        id="mobile-search"
        className="u-flex u-flexAlignCenter u-flexCol u-padding3gu u-marginBottom2gu"
        onMouseLeave={onSearchLeave}
      >
        {autoCompleteData && autoCompleteData.length > 0 && (
          <div className="u-bgColorWhite u-textColorDefault u-paddingTop1gu">
            {autoCompleteData.map((item, index) => {
              return (
                <div
                  key={item}
                  className={`auto-complete-suggestion u-marginLeft2gu u-paddingLeft5gu u-size8of10 u-textSizeMsr ${
                    index === autoCompleteIndex
                      ? 'u-bgColorBrandLight u-textColorWhite'
                      : ''
                  }`}
                  onClick={() => onClickAutoCompItem(item)}
                >
                  {item}
                </div>
              )
            })}
          </div>
        )}
        <form
          className="u-flex u-flexAlignItemsCenter u-flexAuto"
          ref={ref}
          onSubmit={handleSubmit}
        >
          <label className="u-hiddenVisually" htmlFor="cti-mobile-search">
            {name}
          </label>
          <div className="u-flex u-flexAuto u-margin2gu u-borderBottom u-paddingBottom1gu">
            <div className="nav-search-input-container u-flex u-flexAlignItemsCenter u-flexGrow1">
              <span
                className="Icon--material input-search-icon u-textColorBrand u-posAbsolute"
                aria-hidden="true"
              >
                
              </span>
              <input
                type="text"
                id="cti-mobile-search"
                name="search"
                placeholder="Search for products and more..."
                className="Input Input--withIcon Icon--before u-textSecondary u-border0 u-paddingLeft5gu u-paddingTop0 u-paddingBottom0 u-marginRight1gu"
                value={searchText}
                onChange={onSearchChange}
                onKeyUp={onKeyUpSearch}
                autoComplete="off"
              />
              <span
                onClick={onClickClearSearch}
                className={`Icon--material input-close-icon u-textSizeMsrp2 u-marginRight1gu ${
                  searchText?.length === 0 ? 'u-hidden' : ''
                }`}
                aria-hidden="true"
              >
                &#xE5CD;
              </span>
            </div>
            <div className="u-flexExpandLeft">
              <input
                type="submit"
                value="Search"
                className="nav-searchButton Button Button--secondary u-textNoWrap u-border0 u-padding0 u-textColorBrandLight"
              />
            </div>
          </div>
        </form>
      </div>
    )
  }
)
MobileNavigationSearchView.displayName = 'MobileNavigationSearchView'
export default MobileNavigationSearchView
